import { Injectable } from '@angular/core';
import { Config } from '../../config/config.service';
import { LocalStorage } from '../localstorage/localstorage.service';
import * as _ from 'lodash-es';
import { CordovaService } from '../cordova/cordova.service';

@Injectable(
  {
    providedIn: 'root'
  }
)
export class UtilService {

  constructor(
    private _cordovaService: CordovaService,
    private localStorage: LocalStorage,
    private _config: Config
  ) {

  }


  async init(): Promise<void> {
    const isMobile = this._config.CONFIG.isMobile;
    await this.setTheme(isMobile);
    this.checkWebpSupport();
  }

  private checkWebpSupport(): void {
    this.isWebpSupported((isSupported: boolean) => {
      const root = document.documentElement;
      root.classList.add(isSupported ? 'webp' : 'no-webp');
    });
  }

  toObject(array: any, key: string): any {
    return _.keyBy(array, function (e) {
      return e[key];
    });
  }

  getQueryParams($window?: Window): any {
    return this.getQueryParamsFromUrl(($window || window).location.search);
  }

  getQueryParamsFromUrl(queryString: string): any {
    const params: any = {};
    const separated = queryString.includes('?') ? queryString.split('?')[1] : queryString;
    separated.split('&').forEach((param) => {
      const [key, value] = param.split('=');
      params[key] = value;
    });
    return params;
  }

  getQueryParamsFromString(queryString: string) {
    if (!queryString) return null;
    let params: any = {};
    let separated = queryString.includes('?') ? queryString.split('?')[1] : queryString;
    separated.split('&').forEach((param) => {
      const tmp = param.split('=');
      params[tmp[0]] = tmp[1];
    });
    return params;
  }


  isFieldError(errors: any, path: any): any {
    // lodash's result<TResult>() infers TResult from the literal `undefined` default, so without this
    // annotation the method's inferred return type is narrowly `undefined` rather than the real dynamic
    // value at `path` (used truthily by every consumer) — matches the already-`any`-typed params.
    return _.result(errors, path, undefined);
  }

  getUserChannel() {
    if (this._cordovaService.isApp()) {
      return 'MOBILE_APP';
    }
    if (window.matchMedia('(max-width: 639px)').matches) {
      return 'MOBILE';
    }
    return 'DESKTOP';
  }

  isDefined(value: any): boolean {
    return typeof value !== 'undefined' && value !== null;
  }
  isUndefined(value: any): boolean {
    return typeof value === 'undefined' || value === null;
  }

  private isWebpSupported(callback: (supported: boolean) => void): void {
    if (!window.createImageBitmap) {
      callback(false);
      return;
    }
    const webpdata = 'data:image/webp;base64,UklGRiQAAABXRUJQVlA4IBgAAAAwAQCdASoCAAEAAQAcJaQAA3AA/v3AgAA=';
    fetch(webpdata)
      .then(response => response.blob())
      .then(blob =>
        createImageBitmap(blob)
          .then(() => callback(true))
          .catch(() => callback(false)));
  }

  async getInitialTheme(): Promise<string> {
    let currentTheme = 'dark';
    console.log(this.localStorage);
    if (localStorage && localStorage['color-theme']) {
      currentTheme = localStorage['color-theme'];
    }
    return currentTheme ? currentTheme : window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  }

  /**
   * Updates and applies a new theme to the application, optionally based on the platform.
   *
   * @param {boolean} isMobile - A boolean indicating if the theme change is for a mobile device.
   * @param {string} [newTheme] - An optional string representing the desired theme ('dark' or 'light').
   * @return {Promise<string>} A promise that resolves to the newly applied theme.
   */
  async setTheme(isMobile: boolean, newTheme?: string): Promise<string> {
    let currentTheme = 'dark';
    if (localStorage && localStorage['color-theme']) {
      currentTheme = localStorage['color-theme'];
    }
    const theme = newTheme || currentTheme || (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light');

    if (/dark|light/.test(theme)) {
      document.documentElement.classList.remove(currentTheme);
      document.documentElement.classList.add(theme);
      localStorage.setItem('color-theme', theme);
    }
    return theme;
  }
}
